import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { useSelector } from "react-redux";

import { getUuidUser } from "@helpers/getUuidUser";

import { store as fidelity } from "../../../../../components/VerticalLayout/store";
import { useFetchGlobal } from "../../../../../api/hooks";

import { RootState } from "../../../../../redux/store";
import { ConfirmationArchive } from "../../ConfirmationArchive";

import { CustomIconsProps } from "./types";
import { useArchiveIds } from "./useArchiveIds";
import { useActivateFidelity } from "./useActivateFidelity";

import ConsultIconButton from "./icons/ConsultIconButton";
import EditIconButton from "./icons/EditIconButton";
import ArchiveIconButton from "./icons/ArchiveIconButton";
import UnarchiveIconButton from "./icons/UnarchiveIconButton";

export function CustomIconsWrapper({
    e,
    setShopId,
    setFidelity,
    setIsModalOpened,
    isModalOpened,
    setDataIsUpdated,
    setSelectedRows,
    isFidelityArchived,
    setIsAddFidelityClicked,
    isAddFidelityClicked,
    selectedRows,
    setLocalFilterActive,
    setIsModalOpenedSupport,
    setIsConsult,
    setCodeSupport,
}: CustomIconsProps) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const shopsFidelityData = useSelector(
        (s: RootState) => s.fidelity.shopsFidelityData
    );
    const archivedFidelityFranchise = useSelector(
        (s: RootState) => s.fidelity.archivedFidelityFranchise
    );
    const isActionsClicked = useSelector(
        (s: RootState) => s.fidelity.isActionsClicked
    );
    const isEdited = useSelector((s: RootState) => s.fidelity.isEdited);
    const modify = useSelector((s: RootState) => s.fidelity.modify);
    const fidelityData = useSelector((s: RootState) => s.fidelity.fidelityData);
    const numberArchived = useSelector(
        (s: RootState) => s.fidelity.numberArchived
    );
    const numberActive = useSelector((s: RootState) => s.fidelity.numberActive);
    const isSupportCodeValid = useSelector(
        (s: RootState) => s.fidelity.isSupportCodeValid
    );
    const isLoading = useSelector((s: RootState) => s.fidelity.isLoading);
    const { franchiseID, oneShop, userID, operatorID } = useSnapshot(fidelity);

    const [isFidelityClicked, setIsFidelityClicked] = React.useState(false);
    const [isArchiveModalOpened, setIsArchiveModalOpened] = React.useState(
        false
    );

    const uuidUser = getUuidUser();
    const row = e.selectedRow;

    const { dataAssociate, dataArchive } = useArchiveIds(
        oneShop,
        shopsFidelityData,
        archivedFidelityFranchise
    );

    const activateFidelity = useActivateFidelity({
        row,
        userID,
        franchiseID,
        operatorID,
        uuidUser,
        fetchGlobal,
        t,
    });

    const isLeafRow = row?.subRows === undefined;
    const showConfirmArchive =
        isArchiveModalOpened || (isFidelityClicked && isSupportCodeValid);

    return (
        <React.Fragment>
            {isLeafRow ? (
                <div className="d-flex justify-content-around">
                    {modify === false ? (
                        <ConsultIconButton
                            row={row}
                            isEdited={isEdited}
                            isActionsClicked={isActionsClicked}
                            setShopId={setShopId}
                            setFidelity={setFidelity}
                            setIsAddFidelityClicked={setIsAddFidelityClicked}
                            setLocalFilterActive={setLocalFilterActive}
                            setIsConsult={setIsConsult}
                            t={t}
                        />
                    ) : null}

                    {modify === true ? (
                        <>
                            <EditIconButton
                                row={row}
                                oneShop={oneShop}
                                isEdited={isEdited}
                                isActionsClicked={isActionsClicked}
                                isFidelityArchived={isFidelityArchived}
                                isLoading={isLoading}
                                setShopId={setShopId}
                                setFidelity={setFidelity}
                                setIsAddFidelityClicked={
                                    setIsAddFidelityClicked
                                }
                                setLocalFilterActive={setLocalFilterActive}
                                t={t}
                            />

                            {!isFidelityArchived ? (
                                <ArchiveIconButton
                                    row={row}
                                    oneShop={oneShop}
                                    isEdited={isEdited}
                                    isActionsClicked={isActionsClicked}
                                    isLoading={isLoading}
                                    dataAssociate={dataAssociate}
                                    setSelectedRows={setSelectedRows}
                                    setIsAddFidelityClicked={
                                        setIsAddFidelityClicked
                                    }
                                    setIsFidelityClicked={setIsFidelityClicked}
                                    setIsModalOpenedSupport={
                                        setIsModalOpenedSupport
                                    }
                                    setIsArchiveModalOpened={
                                        setIsArchiveModalOpened
                                    }
                                    t={t}
                                />
                            ) : (
                                <UnarchiveIconButton
                                    row={row}
                                    oneShop={oneShop}
                                    isLoading={isLoading}
                                    isModalOpened={isModalOpened}
                                    numberActive={numberActive}
                                    numberArchived={numberArchived}
                                    fidelityData={fidelityData}
                                    dataArchive={dataArchive}
                                    setIsModalOpened={setIsModalOpened}
                                    setFidelity={setFidelity}
                                    setSelectedRows={setSelectedRows}
                                    activateFidelity={activateFidelity}
                                    t={t}
                                />
                            )}
                        </>
                    ) : null}
                </div>
            ) : null}

            {showConfirmArchive ? (
                <ConfirmationArchive
                    isModalOpened={showConfirmArchive}
                    setIsModalOpened={setIsArchiveModalOpened}
                    e={e}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                    setCodeSupport={setCodeSupport}
                />
            ) : null}
        </React.Fragment>
    );
}
